/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useState } from 'react';

import { useUtils } from '../../core/hooks/useUtils';
import { getMineTeamRoomsAction } from '../../store/MineTeamRooms/action';
import { getSharedTeamRoomsAction } from '../../store/SharedTeamRooms/action';

export type ITab = 'Created by me' | 'Shared with me';
interface IOutput {
	state: HookState;
	tabs: Array<ITab>;
	activeTab: ITab;
	isLoading: boolean;
	data: any;
	onTab(activeTab: string): void;
}

interface HookState {
	activeTab: ITab;
	isLoading: boolean;
	isScrolled: boolean;
	data: any;
}

const tabs: Array<ITab> = ['Created by me', 'Shared with me'];

export default function useHook(): IOutput {
	const {
		dispatch,
		store: { mineTeamRooms, sharedTeamRooms },
	} = useUtils();

	const [state, setState] = useState<HookState>({
		activeTab: 'Created by me',
		isLoading: true,
		isScrolled: false,
		data: [],
	});

	useEffect(() => {
		window.addEventListener('scroll', handleResize);
		return () => window.removeEventListener('scroll', handleResize);
	}, []);

	useEffect(() => {
		if (activeTab !== 'Created by me') return;
		const { isLoading, isLoaded, data } = mineTeamRooms;
		if (!isLoading || isLoaded) {
			setState(prev => ({ ...prev, isLoading: false, data }));
		}
	}, [mineTeamRooms]);

	useEffect(() => {
		if (activeTab !== 'Shared with me') return;
		const { isLoading, isLoaded, data } = sharedTeamRooms;
		if (!isLoading || isLoaded) {
			setState(prev => ({ ...prev, isLoading: false, data }));
		}
	}, [sharedTeamRooms]);

	useEffect(() => {
		setTimeout(() => {
			if (activeTab === 'Created by me') {
				dispatch(getMineTeamRoomsAction());
			} else {
				dispatch(getSharedTeamRoomsAction());
			}
		}, 0);
	}, [state.activeTab]);

	const handleResize = () => {
		setState(prev => ({ ...prev, isScrolled: window.pageYOffset > 0 }));
	};

	const onTab = useCallback(
		(activeTab: ITab) => {
			if (activeTab === state.activeTab) return;
			setState(prev => ({ ...prev, activeTab, isLoading: true }));
		},
		[state.activeTab]
	);

	const { activeTab, isLoading, data } = state;

	return {
		state,
		tabs,
		activeTab,
		isLoading,
		data,
		onTab,
	};
}
